/*
 * FAQ — comportement partagé HP + pages internes.
 *
 *  1. HP : markup custom .faq-inner[data-faq] (templates/components/faq-cards.twig).
 *     Chips de filtre par catégorie → affiche/masque les cartes (.faq-card[data-cat]).
 *
 *  2. Pages internes : blocs FAQ Rank Math. Le module Alpha « rank-math-faq »
 *     transforme leur markup en accordéon Bootstrap ; on le reconvertit en CARTES
 *     OUVERTES réutilisant les mêmes classes .faq-card* (rendu unifié, sans filtre).
 *
 * Timing : on lit depuis les classes stables (.rank-math-block / .rank-math-list-item,
 * présentes avant ET après la transformation Alpha) et on s'exécute sur DOMContentLoaded,
 * donc après l'exécution des scripts de bloc en fin de <body> → indépendant de l'ordre.
 */

const NUM_PAD_LENGTH = 2

function pad2(value) {
  return String(value).padStart(NUM_PAD_LENGTH, '0')
}

// --- 1. Filtre des cartes (HP) ----------------------------------------------
function setupFaqFilters(root) {
  const filters = Array.from(root.querySelectorAll('.faq-filter'))
  const cards = Array.from(root.querySelectorAll('.faq-card'))

  if (!filters.length || !cards.length) {
    return
  }

  filters.forEach((button) => {
    button.addEventListener('click', () => {
      const category = button.dataset.cat

      filters.forEach((other) => {
        const isActive = other === button
        other.classList.toggle('active', isActive)
        other.setAttribute('aria-selected', isActive ? 'true' : 'false')
      })

      cards.forEach((card) => {
        const show = category === 'all' || card.dataset.cat === category
        card.hidden = !show

        if (show) {
          card.classList.remove('fade-in')
          card.getBoundingClientRect() // force un reflow pour relancer l'animation
          card.classList.add('fade-in')
        }
      })
    })
  })
}

// --- 2. Conversion d'un bloc FAQ Rank Math en cartes ouvertes (pages internes) ---
function convertRankMathFaq(block) {
  if (block.dataset.faqConverted) {
    return
  }

  const list = block.querySelector('.rank-math-list')
  const items = list ? Array.from(list.querySelectorAll('.rank-math-list-item')) : []

  if (!items.length) {
    return
  }

  list.classList.add('faq-cards')

  items.forEach((item, index) => {
    const questionEl = item.querySelector('.rank-math-question')
    // Après transfo Alpha la réponse est dans .accordion-body ; sinon dans .rank-math-answer.
    const answerEl = item.querySelector('.accordion-body') || item.querySelector('.rank-math-answer')

    const head = document.createElement('div')
    head.className = 'faq-card-head'
    const num = document.createElement('span')
    num.className = 'faq-card-num'
    num.textContent = pad2(index + 1)
    head.append(num)

    const question = document.createElement('h3')
    question.className = 'faq-card-question'
    question.textContent = questionEl ? questionEl.textContent.trim() : ''

    const answer = document.createElement('div')
    answer.className = 'faq-card-answer'
    answer.innerHTML = answerEl ? answerEl.innerHTML.trim() : ''

    item.removeAttribute('id')
    item.className = `faq-card${index === 0 ? ' faq-card-feature' : ''}`
    item.replaceChildren(head, question, answer)
  })

  block.dataset.faqConverted = '1'
}

function init() {
  document.querySelectorAll('[data-faq]').forEach(setupFaqFilters)
  document.querySelectorAll('.rank-math-block').forEach(convertRankMathFaq)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
